export enum Allergies {
  MEDICINES = 'MEDICINES',
  FOOD = 'FOOD',
  PRODUCT = 'PRODUCT'
}
